<header class="page-head">
  <div class="page-head__identity">
    <span class="page-head__icon"><i class="fa fa-university"></i></span>
    <div>
      <h1 class="page-head__title">Agências</h1>
      <p class="page-head__subtitle">Agências e parceiros com as comissões por período.</p>
    </div>
  </div>
</header>

<form class="filter-bar filter-bar--selects" (submit)="pageChanged(1)" data-testid="agencies-filters">
  <div class="search-wrap grow">
    <i class="fa fa-search"></i>
    <input type="text" name="filter" id="filter" class="form-control" placeholder="Pesquisar pelo nome ou e-mail"
      [(ngModel)]="filter" data-testid="input-search-agency" />
    <button type="submit" class="search-go" aria-label="Pesquisar">
      <i class="fa fa-search"></i>
    </button>
  </div>
  <div class="field">
    <label for="order">Ordenar por</label>
    <select name="order" id="order" class="form-select" [ngModel]="orderSelectValue"
      (ngModelChange)="orderChanged($event)" data-testid="select-agency-order">
      <option value="pending|0">Comissão pendente (maior primeiro)</option>
      <option value="pending|1">Comissão pendente (menor primeiro)</option>
      <option value="name|0">Nome A→Z</option>
      <option value="name|1">Nome Z→A</option>
    </select>
  </div>
</form>

<app-skeleton *ngIf="loadingAgencies" variant="table-row" [count]="6" [columns]="4"
  label="Carregando as agências" data-testid="agencies-loading"></app-skeleton>

<div class="sf-card empty" *ngIf="agenciesError && !loadingAgencies" data-testid="agencies-error">
  <i class="fa fa-exclamation-triangle"></i>
  <p><strong>Não foi possível carregar as agências</strong></p>
  <p class="field-hint">Tente de novo em instantes. Se continuar, fale com o suporte.</p>
  <button type="button" class="sf-btn sf-btn--primary sf-btn--sm" (click)="listAgencies()">
    <i class="fa fa-refresh"></i> Tentar de novo
  </button>
</div>

<ng-container *ngIf="agencies$ | async as result">
  <div *ngIf="result.data.length === 0" class="sf-card empty" data-testid="agencies-empty">
    <i class="fa fa-university"></i>
    <p *ngIf="filter">Nenhuma agência encontrada com esse filtro.</p>
    <ng-container *ngIf="!filter">
      <p><strong>Nenhuma agência cadastrada</strong></p>
      <p class="field-hint">Agências e parceiros aparecem aqui quando o perfil do usuário é Agência ou Parceiro.</p>
    </ng-container>
  </div>

  <div class="sf-card ag-card" *ngFor="let agency of result.data" data-testid="agency-card">
    <div class="ag-head">
      <span class="av">{{ initials(agency.name) }}</span>
      <div class="ag-head__info">
        <strong>{{ agency.name }}</strong>
        <div class="field-hint" *ngIf="agency.pix_key">chave pix: {{ agency.pix_key }}</div>
        <div class="field-hint no-pix" *ngIf="!agency.pix_key">sem chave pix</div>
      </div>
      <a class="sf-btn sf-btn--secondary sf-btn--sm push"
        [routerLink]="['/partner-management', agency.id, 'payments']"
        *ngIf="agency.commissions.length > 0">
        <i class="fa fa-search"></i> Visualizar pagamentos
      </a>
    </div>

    <table class="table" *ngIf="agency.commissions.length > 0">
      <thead>
        <tr>
          <th>Período</th>
          <th class="text-end">Valor pendente</th>
          <th class="text-end">Valor pago</th>
          <th>Status</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let commission of agency.commissions">
          <tr *ngIf="hasValues(commission) || showPendings.includes(agency)" data-testid="commission-row"
            [class.zeroed]="!hasValues(commission)">
            <td><strong>{{ commission.period | period }}</strong></td>
            <td class="text-end" [class.muted]="getPendingAmount(commission) === 0">
              {{ getPendingAmount(commission) | numberFormat : "R$ " : true : 2 }}
            </td>
            <td class="text-end paid">{{ getPaidAmount(commission) | numberFormat : "R$ " : true : 2 }}</td>
            <td>
              <span class="status-pill status-pill--sm"
                [class.status-pill--warn]="commission.status === 'pending'"
                [class.status-pill--ok]="commission.status !== 'pending'">
                {{ showStatus(commission) }}
              </span>
            </td>
            <td class="text-end">
              <button type="button" class="sf-btn sf-btn--primary sf-btn--sm" (click)="register(agency, commission)"
                *ngIf="commission.status === 'pending'" data-testid="btn-register-payment">
                <i class="fa fa-plus-circle"></i> Registrar
              </button>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>

    <button type="button" class="zeroed-toggle" *ngIf="zeroedCount(agency) > 0" (click)="alternateHiddenStatus(agency)"
      data-testid="btn-toggle-zeroed">
      <i class="fa" [ngClass]="showPendings.includes(agency) ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
      {{ showPendings.includes(agency) ? 'ocultar' : 'mostrar' }} {{ zeroedCount(agency) }}
      {{ zeroedCount(agency) === 1 ? 'período zerado' : 'períodos zerados' }}
    </button>
  </div>

  <app-pagination
    *ngIf="result.data.length > 0"
    look="v2"
    [currentPage]="result.current_page"
    [itemsPerPage]="result.per_page"
    [totalItems]="result.total"
    (pageChanged)="pageChanged($event)"
  ></app-pagination>
</ng-container>

<ng-template #paymentModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      <i class="fa fa-plus-circle"></i> Registrar pagamento
    </h4>
    <button type="button" class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm" aria-label="Fechar" (click)="modal.dismiss()">
      <i class="fa fa-times"></i>
    </button>
  </div>

  <div class="modal-body">
    <form [formGroup]="paymentForm" class="field-grid field-grid--2">
      <div class="field">
        <label>Valor *</label>
        <span class="form-control readonly">{{ paymentForm.get("amount").value | numberFormat : "R$ " : true : 2 }}</span>
      </div>
      <div class="field">
        <label>Período *</label>
        <span class="form-control readonly">{{ paymentForm.get("period").value | period }}</span>
      </div>
      <div class="field">
        <label for="payment_date">Data do pagamento *</label>
        <input type="date" name="payment_date" id="payment_date" class="form-control" formControlName="payment_date" />
        <span class="field-hint">Não pode ser depois de hoje.</span>
      </div>
      <div class="field field--wide">
        <label for="description">Observação</label>
        <textarea name="description" id="description" class="form-control" rows="3" formControlName="description"></textarea>
      </div>
    </form>
    <span class="field-hint">(*) campos obrigatórios</span>
  </div>

  <div class="modal-footer">
    <button type="button" class="sf-btn sf-btn--ghost push" (click)="modal.close('NO')">Cancelar</button>
    <button type="button" class="sf-btn sf-btn--primary" (click)="save(modal)" [disabled]="paymentForm.invalid"
      data-testid="btn-save-payment">
      <i class="fa fa-check"></i> Salvar
    </button>
  </div>
</ng-template>
